export default __webpack_public_path__ + "static/media/6.e3272ce4.jpg";